<template>
  <div style="height: 100%;overflow: auto;" v-loading="isLoading">
    <div class="quote">
      {{ serviceName }}
      <el-button size="mini" @click="back" style="position: absolute;right: 50px;" round>返回</el-button>
    </div>
    <mavon-editor
                  :style="{height: pageHeight - 62 + 'px'}"
                  :toolbarsFlag="false"
                  :editable="false"
                  :subfield="false"
                  codeStyle="androidstudio"
                  defaultOpen="preview"
                  v-model="document">
    </mavon-editor>
  </div>
</template>

<script>
  import util from '@/libs/util'
  import {addResizeListener, removeResizeListener} from 'element-ui/src/utils/resize-event'
  export default {
    name: 'service-document-show',
    data() {
      return {
        document: '',
        serviceId: this.$route.query.parentId,
        serviceName: null,
        pageHeight: 800,
        isLoading: false
      }
    },
    mounted() {
      this.getDocument()
      this.$nextTick(this.update)
      addResizeListener(this.$el, this.update)
    },
    beforeDestroy() {
      removeResizeListener(this.$el, this.update)
    },
    methods: {
      update() {
        // 设置el-scrollbar中内层div高度与最外层高度一致
        this.pageHeight = this.$el.offsetHeight
      },
      getDocument: function () {
        this.isLoading = true
        util.ajax.get('/entity/dev/apiServiceDetail/document/' + this.serviceId).then(res => {
          this.isLoading = false
          if (res.data.meta.errCode === 0) {
            this.document = res.data.data.document
            this.serviceName = res.data.data.serviceName
          } else {
            this.$notify.warning({title: '警告', message: res.data.meta.errMsg})
          }
        }).catch(err => {
          this.isLoading = false
          console.warn(err)
          this.$notify.error({title: '错误', message: '系统错误'})
        })
      },
      back: function () {
        util.routerBack(this)
      }
    }
  }
</script>

<style scoped>
  .quote {
    margin-bottom: 10px;
    padding: 15px;
    line-height: 22px;
    border-left: 5px solid #66b1ff;
    border-radius: 0 2px 2px 0;
    background-color: #f2f2f2;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/custom/components/grid/service/service-document-show.vue